
export default function itemEmpty(properties) {
  const item = {}
  Object.keys(properties).map((property) => {
    if (properties[property].type === 'array') {
      item[property] = []
      return
    }
    item[property] = null
  })
  return item
}
